module.exports = __webpack_public_path__ + "img/dreams-5-gen-pro-portrait.76b7c1c.png";